// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, OnInit } from '@angular/core';
import {ISoftwareVersion} from '../../../types/subscription';
import {D3eService} from '../../../services/d3e-service';
import multiDownload from 'multi-download';
import {ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {getDownloadFilename} from '../d3e-invitation/welcome/welcome.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-downloaded-free',
    templateUrl: './downloaded-free.component.html',
    styleUrls: ['./downloaded-free.component.scss'],
    standalone: false
})
export class DownloadedFreeComponent implements OnInit {
  style = {
    'width': '1050px',
    'margin': '100px auto'
  }
  version: ISoftwareVersion = null;
  subscription_id = '';

  fHeader: string;
  fAutoDownload: string;
  fClickHere: string;
  fEmailVerify: string;
  fEmailA: string;
  fEmailB: string;
  fEmailC: string;
  fInfo: string;
  fLink: string;
  fThanks: string;
  constructor(
      private d3eService: D3eService,
      private route: ActivatedRoute,
      private translate: TranslateService
  ) {
    this.translate.get(['DL_HEADER', 'DL_AUTO_DL', 'DL_CLICKHERE', 'DL_VERIFY', 'DL_EMAILA',
      'DL_EMAILB', 'DL_EMAILC', 'DL_INFO', 'DL_LINK', 'DL_THANKS']).subscribe(vals => {
        this.fHeader = vals['DL_HEADER'];
        this.fAutoDownload = vals['DL_AUTO_DL'];
        this.fClickHere = vals['DL_CLICKHERE'];
        this.fEmailVerify = vals['DL_VERIFY'];
        this.fEmailA = vals['DL_EMAILA'];
        this.fEmailB = vals['DL_EMAILB'];
        this.fEmailC = vals['DL_EMAILC'];
        this.fInfo = vals['DL_INFO'];
        this.fLink = vals['DL_LINK'];
        this.fThanks = vals['DL_THANKS'];
    });
    this.d3eService.get_d3e_software_version()
      .pipe(untilDestroyed(this))
      .subscribe((version: ISoftwareVersion) => this.version = version);
  }

  ngOnInit(): void {
  }

  onDownloadOnlyClick(): void {
    const sub_id = this.route.snapshot.params["uuid"];
    const filename = getDownloadFilename(this.version, sub_id);
    multiDownload([this.version.path], {
      rename: (url, index, urls) => filename,
    })
  }
}
